import React from "react";
import Page from "../../components/general/page";
import CreateNewContactPage from "../../components/parties/create/createNewContactPage";
import { useContext } from "react";
import { RegistryContext } from "../../contexts/RegistryContext";
import { useIntl } from "react-intl";

const CreateNewContactView = ({ isFullscreenOverlay, isPage, pageRef }) => {
  const registryStore = useContext(RegistryContext);
  const cleanData = () => {
    registryStore.setIbanPaymentFormError(null);
    registryStore.setMunicipalityError(null);
    registryStore.setCapError(null);
    registryStore.setProvinceError(null);
    registryStore.setEmailError(null);
    registryStore.setPecError(null);
    registryStore.setIbanError(null);
    registryStore.setInstallments([
      {
        dueDate: { number: "30", interval: "giorni", from: "month-end" },
        amount: 100,
        iban: "",
        paymentMethod: "MP05"
      }
    ]);
  };
  return (
    <Page
      pageRef={pageRef}
      title={useIntl().formatMessage({ id: "addressBook.create.title"})?.toUpperCase()}      
      backUrl={"/parties"}
      actionClick={() => cleanData()}
      isFullscreenOverlay={isFullscreenOverlay}
    >
      <CreateNewContactPage
        registryStore={registryStore}        
        isPage={isPage}
      />
    </Page>
  );
};

export default CreateNewContactView;
